import { render, staticRenderFns } from "./BaseLazyImg.global.vue?vue&type=template&id=55044c24&functional=true&"
import script from "./BaseLazyImg.global.vue?vue&type=script&lang=js&"
export * from "./BaseLazyImg.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports